// import perlin_noise from "../../../assets/custom/textures/perlin_noise.png";
import perlin_noise from "./assets/textureNoise.png";

// export const noiseTexture = new THREE.TextureLoader().load("./textures/add-noiseTexture.png");
export const noiseTexture = new THREE.TextureLoader().load(perlin_noise);
